import React from 'react';
import { HStack, useColorModeValue } from '@cardboard-ui/react';
import { SimpleCard } from 'components/cards/SimpleCard';
import { ListItem } from './ListItem';
import { ItemPlaceholderProps, ItemProps } from './index';
import { Handle } from 'components/ItemHandle/components/Handle';
import { FilePlusIcon } from 'components/icons';

export const InlineItem = (props: ItemProps) => {
  return (
    <SimpleCard onClick={props.onClick}>
      <ListItem {...props} linkBox={!props.onClick} />
    </SimpleCard>
  );
};

export const InlineItemPlaceHolder = ({
  onClick,
  name,
}: ItemPlaceholderProps) => {
  const bg = useColorModeValue('blue.50', 'gray.600');
  return (
    <SimpleCard bg={bg} onClick={onClick}>
      <HStack w="100%" data-qa="item" spacing={0.5}>
        <Handle name={name} icon={<FilePlusIcon />} />
      </HStack>
    </SimpleCard>
  );
};
